'use client';

import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { MobileCollapseProps } from '@/types/dataTypes';
import Image from 'next/image';
import { zzjiechen_arctype } from '@prisma/client';

function MobileCollapse({
	title,
	seriesData,
	subSeriesData,
	typeId,
	path,
}: MobileCollapseProps) {
	const router = useRouter();

	let typeData: zzjiechen_arctype[] | undefined = seriesData;

	if (seriesData && typeId && !isNaN(typeId)) {
		let selectedIndex = -1;
		seriesData.some((item, index) => {
			if (item.id === typeId) {
				selectedIndex = index;
				return;
			}
		});
		if (subSeriesData) {
			if (selectedIndex === -1) {
				for (const item of subSeriesData) {
					if (item.some((subItem) => subItem.id === typeId)) {
						typeData = item;
					}
				}
			} else {
				typeData = subSeriesData[selectedIndex];
			}
		}
	}

	return (
		<>
			<div className="w-[100vw] h-[5rem] bg-[#f6f6f6] shadow-[inset_1_0_2rem_rgba(0,0,0,.3)] flex flex-row items-center p-7">
				<div
					id="backBtn"
					className="w-[2rem] h-[2rem] relative ml-2"
					onClick={() => {
						router.back();
					}}
				>
					<Image
						className="w-[2rem] h-[2rem] object-contain"
						src="/m_img/return.png"
						alt=""
						fill
						sizes="6vw"
					/>
				</div>

				<span
					className={`text-[1.7rem] text-[#666] mx-auto ${
						typeData && typeData.length > 0 ? '' : 'pr-[2rem]'
					}`}
				>
					{title}
				</span>
				{typeData && typeData.length > 0 ? (
					<div
						className="w-[3rem] h-[3.5rem] relative hs-collapse-toggle"
						data-hs-collapse="#hs-basic-collapse-heading"
					>
						<Image
							className="object-contain"
							src="/m_img/more.png"
							alt=""
							fill
							sizes="100vw"
						/>
					</div>
				) : undefined}
			</div>
			{typeData && (
				<div
					id="hs-basic-collapse-heading"
					className="bg-[#fff] hs-collapse hidden w-full overflow-hidden transition-[height] duration-300 border-b border-[#e6e6e6] border-solid"
					aria-labelledby="hs-basic-collapse"
				>
					<div className="mt-5">
						<ul className="p-4 flex flex-wrap">
							{typeData.map((item, index) => {
								return (
									<li
										key={item.id}
										className={`w-[11.2rem] ${
											typeId === item.id
												? 'bg-[#1a455d] text-[#fff]'
												: 'bg-[#f3f3f3] text-[#666] '
										} whitespace-nowrap overflow-hidden  text-ellipsis rounded-[4px] border-[1px] border-solid border-[#e6e6e6] ml-[.5rem] text-center leading-[32px] mb-[.5rem] `}
									>
										<Link href={`${path}/${item.id}`}>
											{item.typename}
										</Link>
									</li>
								);
							})}
						</ul>
					</div>
				</div>
			)}
		</>
	);
}

export default MobileCollapse;
